import axios from "axios";

const DICTIONARIES_URL = import.meta.env.VITE_DICTIONARIES_URL;

export const CitiesListService = (departmentId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const citiesList = await axios.get(
        `${DICTIONARIES_URL}/v1/city/getCityList/${departmentId}`
      );
      resolve(citiesList.data);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};